import type { JSX, PropsWithChildren } from 'react';

import { useLocation } from 'react-router';

import { Redirect } from '@change-corgi/core/react/router';

import { useStartAPetitionPageFcmExperiments } from '../../pageFcmExperiments';

import { StepStateContextProvider } from './context';
import { useStepState } from './hooks/useStepState';

export function StepStateProvider({ children }: PropsWithChildren<EmptyProps>): JSX.Element | null {
	const stepState = useStepState();
	const location = useLocation();
	const experiments = useStartAPetitionPageFcmExperiments();

	const isS2SFlow = Boolean(stepState.data.metadata.flowKey === 'supporter-to-starter');
	if (!experiments.startAPetitionV3EnabledExperiment.variation.includes('control') && !isS2SFlow)
		return <Redirect to={`/start-a-petition/intro${location.search}`} />;

	return <StepStateContextProvider {...stepState}>{children}</StepStateContextProvider>;
}
